import { render, staticRenderFns } from "./faultDiaresPage.vue?vue&type=template&id=382c7190&scoped=true"
import script from "./faultDiaresPage.vue?vue&type=script&lang=js"
export * from "./faultDiaresPage.vue?vue&type=script&lang=js"
import style0 from "./faultDiaresPage.vue?vue&type=style&index=0&id=382c7190&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "382c7190",
  null
  
)

export default component.exports